import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useWalletStore } from '../store/walletStore'
import { AudioControls } from './AudioControls'
import { useMetaStore } from '../meta/metaStore'

/**
 * Always-visible product chrome. Match Coins do not live here.
 * Ingots are persistent meta currency (Research).
 */
export const GlobalTopbar: React.FC = () => {
  const { isConnected, address } = useWalletStore()
  const ingots = useMetaStore((s) => s.ingots)
  const location = useLocation()
  const onResearch = location.pathname.startsWith('/research')
  const short =
    address && address.length > 10
      ? `${address.slice(0, 6)}…${address.slice(-4)}`
      : address

  return (
    <header className="global-topbar">
      <div className="global-topbar__brand">
        <Link to="/" className="global-topbar__title">
          Shapes TD
        </Link>
      </div>

      <div className="global-topbar__slots">
        <AudioControls />
        <div
          className="topbar-slot"
          data-testid="topbar-ingots"
          title="Persistent Ingots (not match Coins)"
          aria-label={`${ingots} Ingots`}
        >
          ◆ {ingots}
        </div>
        {!onResearch ? (
          <Link
            className="topbar-slot"
            to="/research"
            data-testid="topbar-research"
            title="Tower Research"
          >
            Research
          </Link>
        ) : null}
        {isConnected && short ? (
          <div className="topbar-slot" title="Connected wallet">
            {short}
          </div>
        ) : (
          <div className="topbar-slot topbar-slot--muted" title="Account / wallet — later">
            Account
          </div>
        )}
      </div>
    </header>
  )
}
